/**
 * Deterministic smooth turbulence in roughly [-1, 1], a function of time only.
 * Layered sines stand in for gust/lull structure between sparse weather samples.
 * Being a pure function of t keeps the whole engine reproducible.
 */
export function turbulence(t: number): number {
  return (
    0.55 * Math.sin(t * 0.7) +
    0.3 * Math.sin(t * 1.83 + 1.3) +
    0.15 * Math.sin(t * 3.1 + 2.6)
  );
}
